import Button from 'devextreme-react/button';
import './FormCommonStyle.scss';
import { useSavePrepForInstallChecklistForm } from '../api/save-prepForInstallChecklistForm';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';

const PrepForInstallChecklistForm: React.FC<{
    retailOrderID: number, retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {
    const [mayISpeakTo, setMayISpeakTo] = useState(false);
    const [introduceYourself, setIntroduceYourself] = useState(false);
    const [scheduleProject, setScheduleProject] = useState(false);
    const [lowesSurveyScore, setLowesSurveyScore] = useState(false);
    const [decisionMaker, setDecisionMaker] = useState(false);
    const [priorToTheArrival, setPriorToTheArrival] = useState(false);
    const [removeExistingCountertop, setRemoveExistingCountertop] = useState(false);
    const [allApplicancesMustBeRemoved, setAllApplicancesMustBeRemoved] = useState(false);
    const [clearEntryWay, setClearEntryWay] = useState(false);
    const [reconnectPlumbing, setReconnectPlumbing] = useState(false);
    const [beforeWipingDown, setBeforeWipingDown] = useState(false);
    const [finalWallPreparation, setFinalWallPreparation] = useState(false);
    const [provide4Hour, setProvide4Hour] = useState(false);
    const [lowesSurveyPerfect, setLowesSurveyPerfect] = useState(false);
    const [thankCustomerForPurchase, setThankCustomerForPurchase] = useState(false);
    const [noteText, setNoteText] = useState('');

    const handleReset = () => {
        setMayISpeakTo(false);
        setIntroduceYourself(false);
        setScheduleProject(false);
        setLowesSurveyScore(false);
        setDecisionMaker(false);
        setPriorToTheArrival(false);
        setRemoveExistingCountertop(false);
        setAllApplicancesMustBeRemoved(false);
        setClearEntryWay(false);
        setReconnectPlumbing(false);
        setBeforeWipingDown(false);
        setFinalWallPreparation(false);
        setProvide4Hour(false);
        setLowesSurveyPerfect(false);
        setThankCustomerForPurchase(false);
        setNoteText('');
    };

    const savePrepForInstallChecklist = useSavePrepForInstallChecklistForm(
        {
            formObject: {
                RetailOrderID: retailOrderID,
                RetailOrderNo: retailOrderNumber,
                MayISpeakTo: mayISpeakTo,
                IntroduceTourself: introduceYourself,
                ScheduleProject: scheduleProject,
                LowesSurveyScore: lowesSurveyScore,
                DecisionMaker: decisionMaker,
                PriorToTheArrival: priorToTheArrival,
                RemoveExistingCountertop: removeExistingCountertop,
                AllApplicancesMustBeRemoved: allApplicancesMustBeRemoved,
                ClearEntryWay: clearEntryWay,
                ReconnectPlumbing: reconnectPlumbing,
                BeforeWipingDown: beforeWipingDown,
                FinalWallPreparation: finalWallPreparation,
                Provide4Hour: provide4Hour,
                LowesSurveyPerfect: lowesSurveyPerfect,
                ThankCustomerForPurchase: thankCustomerForPurchase,       
                NoteText: noteText
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleNoteText= (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNoteText(event.target.value);
    };

    return (
        <div>
            <div className='main-header'>
                <h1>Project Manager - Prep for Install Checklist 2024</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={mayISpeakTo} onChange={(e) => setMayISpeakTo(e.target.checked)} />
                        “May I speak to (customer name)”
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={introduceYourself} onChange={(e) => setIntroduceYourself(e.target.checked)} />
                        Introduce yourself, your company – in partnership with Lowe’s, and that you’re calling to
                        schedule their installation appointment for their Lowe’s countertop project.
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>For Countertop Install</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={scheduleProject} onChange={(e) => setScheduleProject(e.target.checked)} />
                        <b>Schedule project</b>
                    </label>
                    <div className='section-row-section-hint'>
                        »  Review the Prep for Install Checklist (use the script below) and that they will receive a copy
                        from Lowe’s on the installation appointment confirmation email
                    </div>
                    <div className='section-row-section-hint'>
                        »  Mention the length of the install appointment
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={lowesSurveyScore} onChange={(e) => setLowesSurveyScore(e.target.checked)} />
                        <b>Lowe’s survey perfect score expectation – “serves as our report card and only scored on a
                            perfect 10.”</b>
                    </label>
                    <div className='section-row-section-hint-italic'>
                        »  "Delivering a 10-star countertop experience is our aim, and we're eager to earn your
                        recommendation through our report card. Your feedback is invaluable in helping us
                        achieve a perfect 10 star review."
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={decisionMaker} onChange={(e) => setDecisionMaker(e.target.checked)} />
                        The decision maker (over the age of 18) must be on site. This person is required to sign off on the
                        work completed
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={priorToTheArrival} onChange={(e) => setPriorToTheArrival(e.target.checked)} />
                        Prior to the arrival for the countertop installation, ALL surface areas MUST be cleared off, ALL
                        base cabinets MUST be emptied, and ALL base cabinet drawers MUST be removed and stored
                        in a safe place, to ensure successful project installation.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={removeExistingCountertop} onChange={(e) => setRemoveExistingCountertop(e.target.checked)} />
                        Remove existing countertops, backsplashes, & sills if we are not contracted to do so.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={allApplicancesMustBeRemoved} onChange={(e) => setAllApplicancesMustBeRemoved(e.target.checked)} />
                        If we are not contracted to do so, all appliances MUST be removed from the installation area
                        prior to the arrival for the countertop installation to eliminate the risk of damage. Your Installer
                        assumes no liability for damage (appliances, flooring, etc.) if appliances need to be moved
                        during your installation.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={clearEntryWay} onChange={(e) => setClearEntryWay(e.target.checked)} />
                        Clear entryway to the workspace, interior & exterior. Keep pets & children clear of the work area.
                    </label>
                </div>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>After Countertop Install – Please wait 24 hours</span></div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={reconnectPlumbing} onChange={(e) => setReconnectPlumbing(e.target.checked)} />
                        To reconnect plumbing unless we are providing this service.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={beforeWipingDown} onChange={(e) => setBeforeWipingDown(e.target.checked)} />
                        Before wiping down any surface at seams or where the countertop or backsplash meets the
                        wall.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={finalWallPreparation} onChange={(e) => setFinalWallPreparation(e.target.checked)} />
                        Final wall preparation (painting, wall papering, tile backsplash, etc.) should NOT be completed
                        prior to countertop installation. Care will be exercised during the countertop removal and/or
                        installation; however, scrapes, punctures, or dings to wall surfaces are possible, as are scratches
                        to cabinetry, and damage to existing tile/laminate backsplashes. As your project is considered
                        an active construction site, these items are deemed incidental damage and are the customer’s
                        responsibility to repair.
                        wall.
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={provide4Hour} onChange={(e) => setProvide4Hour(e.target.checked)} />
                        Provide 4 hour window of arrival
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={lowesSurveyPerfect} onChange={(e) => setLowesSurveyPerfect(e.target.checked)} />
                        <b>Lowe’s survey perfect score expectation</b> – “serves as our <b>report card</b> and only scored on a
                        perfect 10.”
                    </label>
                    <div className='section-row-section-hint-italic'>
                        »  "Delivering a 10-star countertop experience is our aim, and we're eager to earn your
                        recommendation through our report card. Your feedback is invaluable in helping us
                        achieve a perfect 10 star review."
                    </div>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="checkbox" checked={thankCustomerForPurchase} onChange={(e) => setThankCustomerForPurchase(e.target.checked)} />
                        Thank customer for purchase, provide contact information
                    </label>
                </div>
                <div className='section-row'>
                        Notes:
                        <textarea
                            className='input-fullsize-large-height'
                            value={noteText}
                            onChange={handleNoteText}
                            placeholder="Note"
                            rows={5}
                            cols={40}
                        />
                    </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        savePrepForInstallChecklist.mutate();
                    }} >
                </Button>
            </div>
        </div>
    );
};

export default PrepForInstallChecklistForm;
